








































































































































































































































import Vue from 'vue';
import { CrudServiceBase } from '../service/CrudServiceBase';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { DataGrid } from '@questelservices/common-vue';
import { DxSelectBox, DxDateBox } from 'devextreme-vue';
import DxDataGrid, {
  DxColumn,
  DxEditing,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxLookup,
  DxPopup,
  DxStateStoring,
  DxCustomRule,
  DxPaging,
  DxPager
} from 'devextreme-vue/data-grid';
import { DxItem, DxGroupItem, DxButtonItem } from 'devextreme-vue/form';
import DevExpress from 'devextreme';
import { ClientService } from '@/service/ClientService';
import { SelectOption } from '@/models/SelectOption';
import { LoadOptions } from 'devextreme/data/load_options';
import dxDataGrid from 'devextreme/ui/data_grid';
import { RawLocation } from 'vue-router';
import { ClientMatterDataService } from '../service/ClientMatterDataService';
import { ClientMatterDataDropdownDto } from '../models/matter/ClientMatterDataDropdownDto';
import { ClientMatterDataDto } from '@/models/matter/ClientMatterDataDto';
import {
  DxValidator,
  DxRequiredRule,
  DxAsyncRule
} from 'devextreme-vue/validator';
import _ from 'lodash';
import { confirm } from 'devextreme/ui/dialog';
import ClientMatterData from '../views/client-matter-data.vue';

@Component({
  components: {
    DxSelectBox,
    DataGrid,
    DxEditing,
    DxPopup,
    DxItem,
    DxGroupItem,
    DxHeaderFilter,
    DxForm,
    DxColumn,
    DxDateBox,
    DxAsyncRule,
    DxRequiredRule,
    DxCustomRule,
    DxStateStoring,
    DxPaging,
    DxPager
  }
})
export default class ClientDataGrid<T> extends Vue {
  $refs: Vue['$refs'] & {   
   dataGrid?: DataGrid; 
  } = {};

  clientMatterDataService: ClientMatterDataService;
  clients: Array<SelectOption> = [];
  selectedClient: Guid | null = null;
  dataGrid: any;
  dropdownData: Map<string, Array<string>> = new Map<string, Array<string>>();
  initialLoad: boolean = true;

  get routeClientId(): Guid | undefined {
    return this.$route.params['clientId'];
  }

  customStoreOptions: DevExpress.data.CustomStoreOptions = {
    key: 'ClientMatterDataId',
    load: loadOptions => this.loadDataGrid(loadOptions),
    insert: values => this.clientMatterDataService.create(values).catch(this.handleError),
    update: (key, values) => this.clientMatterDataService.edit(key, values).catch(this.handleError),
    remove: key => this.clientMatterDataService.delete(key).catch(this.handleError)
  };

  editingOptions: DevExpress.ui.dxDataGridEditing = {
    allowAdding: true,
    allowUpdating: true,
    allowDeleting: true,
    popup: {
      showTitle: true,
      title: "Client Matter Data Edit",
      width: '60%',
      height: '60%',
      onShown: this.popupShowing
    }
  };
  
  constructor() {
    super();
    this.clientMatterDataService = new ClientMatterDataService();
  }

  mounted() {
    this.loadData();
    this.setClientFromRoute();   
    this.initialLoad = true; 
  }

  @Watch('routeClientId')
  private routeClientIdChange() {
    this.setClientFromRoute();
  }  

  @Watch('selectedClient')
  private async selectedClientChange() {
    // Router will be updated with location matching the current location
    let location: RawLocation = { name: this.$route.name !== null ? this.$route.name : undefined };

    // Include selected client parameter if not null or empty
    if (this.selectedClient) {
      location.params = { clientId: this.selectedClient };
      this.refreshDropdownData();    
    }

    // This is to compare booleans instead of running in to situations where "" !== null !== undefined and having duplicate navigation errors
    let clientSelected = this.selectedClient ? true : false;
    let routeClientSelected = this.routeClientId ? true : false;
    let selectedClientChanged = clientSelected && routeClientSelected && this.selectedClient !== this.routeClientId;

    // If the route / dropdown selected status do not match, or if the selected client has changed, push a router update
    if (clientSelected !== routeClientSelected || selectedClientChanged) {
      await this.$router.push(location);
    }
  }

  private setClientFromRoute() : void {
    // If the route has a parameter for the clientId, select it
    if (this.routeClientId && this.selectedClient !== this.routeClientId) {
      this.selectedClient = this.routeClientId;
    } else if (!this.routeClientId) {
      this.selectedClient = null;
    }
  }

  async refreshDropdownData() {
    if(this.selectedClient) {
      this.dropdownData = (await this.clientMatterDataService.getDropdownData(this.selectedClient)).DropdownData;   
    }    
  } 

  private async loadData() {    
    let clientService = new ClientService();
    let clients = await clientService.getAll();
    this.clients = clients.map(c => {
      return { text: c.ClientName, value: c.ClientId };
    });
  }

  private loadDataGrid(loadOptions: LoadOptions): Promise<any> {        
    if (this.initialLoad) {
      this.clearFiltersAndSorting();
    }
    let clientFilter = ['ClientId', '=', this.selectedClient];
    if (loadOptions.filter) {
      loadOptions.filter = [clientFilter, 'and', loadOptions.filter];
    } else {
      loadOptions.filter = clientFilter;
    }
    return this.clientMatterDataService.search(loadOptions).catch(this.handleError);
  }

  private clearFiltersAndSorting() {
      this.initialLoad = false;
      this.dataGrid.clearFilter();
      this.dataGrid.clearSorting();
  }

  private popupShowing(e: any) : void {
    // Couldn't find a configuration option for this, so changing the style of Save and Cancel when loading the dialog.
    var toolbarItems = e.component.option('toolbarItems');
    toolbarItems[0].options.stylingMode = 'contained';
    toolbarItems[1].options.stylingMode = 'contained';
    toolbarItems[1].options.type = 'normal';
    e.component.option('toolbarItems', toolbarItems);
  }

  protected setAttr(name: string, value: any): any {
    return Object.keys(this.$attrs).indexOf(name) > -1 ? this.$attrs[name] : value;
  }

  private readonly duplicateClientAgentCountryMsg: string = "Client matter data already exists with the selected client-matter-countrycode combination.";

  private handleError(result: any) {
    let message =
      result && result.Message
        ? result.Message
        : 'An unknown error occurred. Please try again, or contact support if the error continues.';

    //remove error and request id from message for this error
    if(message.includes(this.duplicateClientAgentCountryMsg)) {
      message = this.duplicateClientAgentCountryMsg;
    }

    throw message;       
  }

  initNewRow(e: any) {        
    e.data = {
      ClientId: this.selectedClient
    };
  }

  editingStart(e: any) {
    if (!e.data.ClientId) {
      e.data.ClientId = '';
    }   
  }

  rowUpdating(e: any) {       
    e.newData = _.merge({}, e.oldData, e.newData); 

    //check if matter has line items and the matter name would be changed
    if (this.matterHasLineItems(e)) {
      let isCanceled = new Promise((resolve, reject) => {
        let dialogResult = confirm(`Invoicing rows already exist for matter ${e.oldData.MatterName}. Are you sure you want to change the matter name to ${e.newData.MatterName}?`, 'Matter Name Change Warning');
        dialogResult.then((result) => {
            if (result) {
                return resolve(false);
            } else {
                return resolve(true);
            }
        });
      });
      e.cancel = isCanceled;     
    }         
  }

  matterHasLineItems(e: any): boolean {
    let result = false;
    let oldMatterName = e.oldData.MatterName;
    let newMatterName = e.newData.MatterName;

    if (e.oldData.HasLineItems && oldMatterName != undefined && newMatterName != undefined && oldMatterName != newMatterName) {
      result = true;      
    }

    return result;
  }

  dataGridInitialized(e: any): void {
    this.dataGrid = e.component;
  }

  saveEditData(): void {
    if (this.dataGrid) {
      this.dataGrid.focus();
      this.dataGrid.saveEditData();
    }
  }
}
